// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import {jsx} from 'panel';

import {ModalEl} from 'common/components/modal';
import {SpinnerEl} from 'common/components/spinner';
import {SpinnerColor, SpinnerSize} from 'common/components/spinner/types';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

import type {DemoProjectSelector} from './index';
import {DatasetCardEl} from './dataset';

export function template(this: DemoProjectSelector) {
  return (
    <ModalEl
      sel='.mp-demo-selector-modal'
      attrs={{
        closeable: true,
        open: true,
        'grow-to-content': true,
      }}
    >
      <div>
        <div sel='.mp-modal-large-content'>
          <div sel='.header'>
            {this.attr(`is-fyt`) ? this.t(`help.demo-loading`) : this.t(`help.demo-select-dataset`)}
          </div>
          <div sel='.mp-modal-text'>
            {this.attr(`is-fyt`) ? (
              <>
                {this.t(`help.demo-request-title`)}
                <div>{this.t(`help.demo-request-owner`, {ownerEmail: this.attr(`owner-email`)})}</div>
              </>
            ) : (
              this.t(`help.demo-switch-tip`)
            )}
          </div>
          <div sel='.modal-container'>
            {this.state.loadingProjects ? (
              <div sel='.spinner-wrapper'>
                <SpinnerEl
                  attrs={{
                    color: SpinnerColor.Blue,
                    size: SpinnerSize.Large,
                  }}
                />
              </div>
            ) : (
              <>
                <div sel='.datasets-wrapper'>
                  {this.state.demoProjects.map((project) => (
                    <DatasetCardEl
                      attrs={{
                        'img-name': project.icon,
                        text: project.description,
                        'project-id': project.projectId,
                        selected: this.state.selectedDemo === project.description,
                      }}
                      on={{click: () => this.helpers.clickedDataset(project.description)}}
                    />
                  ))}
                </div>
                <div sel='.explore-demo-button'>
                  <ButtonEl
                    attrs={{
                      elref: `submitButton`,
                      theme: ButtonTheme.Primary,
                      disabled: !this.state.selectedDemo || this.state.waitingOnResponse,
                    }}
                    on={{
                      click: () => this.helpers.clickedExploreDemoButton(),
                    }}
                  >
                    {this.state.waitingOnResponse ? (
                      <SpinnerEl attrs={{color: SpinnerColor.White}} />
                    ) : (
                      this.t(`help.demo-cta`)
                    )}
                  </ButtonEl>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </ModalEl>
  );
}
